module.exports = [{"title":"газобаллонное оборудование","id":"gas_equipment"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/engineFeatures.json
// module id = 565
// module chunks = 49